import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as userActions from './user.actions';
import { Injectable } from '@angular/core';
import { map, switchMap, take } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { ConverterService } from '../services/converter.service';
import { of } from 'rxjs';


@Injectable()
export class UserEffects {

  fetchOrders = createEffect(() => this.actions$.pipe(
    ofType(userActions.userFetchingOrdersAction),
    switchMap(() => {
      return this.api.getOrders();
    }),
    map(context => {
      return userActions.userStoreOrdersAction(
        context.result.map(resultItem => this.api.convertOrderToUserOrder(resultItem))
      );
    })
  ));

  userFetchingInfo = createEffect(() => this.actions$.pipe(
    ofType(userActions.userFetchingInfoAction),
    switchMap(() => {
      return this.api.userGet();
    }),
    switchMap(context => {
      if (!context.result || context.error) {
        return of(userActions.userLogoutAction());
      }
      return this.converterService.convertUserResponse(context.result).pipe(
        map(value => {
          return userActions.userSaveAction(value);
        })
      );
    })
  ));

  userUpdateAddress = createEffect(() => this.actions$.pipe(
    ofType(userActions.userUpdatingAddressAction),
    switchMap((action) => {
      const deliveryPoint = action.payload.deliveryPoint;
      return this.api.updateAddress({
        id: action.payload.id,
        country: deliveryPoint.country,
        region: deliveryPoint.region,
        city: deliveryPoint.city,
        street: deliveryPoint.street,
        house: deliveryPoint.house,
        apartment: deliveryPoint.apartment,
        description: deliveryPoint.description,
        latitude: deliveryPoint.latitude,
        longitude: deliveryPoint.longitude
      });
    }),
    switchMap(context => {
      if (context.error) {
        return of(userActions.userLogoutAction());
      }
      return this.converterService.convertUserAddressesResponse(context.result).pipe(
        take(1),
        map(userAddress => {
          return userActions.userUpdateAddressesAction(userAddress);
        })
      );
    })
  ));

  userAddAddress = createEffect(() => this.actions$.pipe(
    ofType(userActions.userAddAddressAction),
    switchMap((action) => {
      const userAddress = action.payload;
      return this.api.addAddress({
        country: userAddress.country,
        region: userAddress.region,
        city: userAddress.city,
        street: userAddress.street,
        house: userAddress.house,
        apartment: userAddress.apartment,
        description: userAddress.description,
        latitude: userAddress.latitude,
        longitude: userAddress.longitude
      });
    }),
    switchMap(context => {
      if (context.error) {
        return of(userActions.userLogoutAction());
      }
      return this.converterService.convertUserAddressResponse(context.result).pipe(
        map(userAddress => {
          return userActions.userStoreAddressesAction(userAddress);
        })
      );
    })
  ));

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private converterService: ConverterService
  ) {

  }

}
